export default "__VITE_ASSET__DGo$wRW6__"